import src from "IMAGE";
export default { src, width: 192, height: 52, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAMBAAMKCAc6ERANYhMRDm4SEA5iGBUSgxMRDnARDwxkAFIdBEwoFQtjFxMRdxkVE48YFRKNGBYSgxcTEYISEQ1lF3EJ3hd32boAAAAASUVORK5CYII="};
